import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import settings from "@src/settings";
import { up, only, down, between } from "styled-breakpoints";
import getGridHeight from "@src/utils/getGridHeight";
import Nav from "./Nav";
import getGridWidth from "@src/utils/getGridWidth";

export const Frame = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
export const ContentBox = styled.div`
	align-self: stretch;
	display: flex;
	& > ${Nav} {
		flex: 1 1 auto;
	}
`;
export const Content = styled.div<{ windowW: number | null }>`
	flex: 0 0 auto;
	height: 660px;
	background-color: #fff;
	border-radius: ${settings.radius.medium}px;
	overflow: hidden;
	position: relative;
	${up("xxl")} {
		flex-basis: ${settings.contentWidth.xxl}px;
	}
	${only("xl")} {
		flex-basis: ${settings.contentWidth.xl}px;
	}
	${only("lg")} {
		flex-basis: ${settings.contentWidth.lg}px;
	}
	${down("lg")} {
		height: ${getGridHeight({ rows: 30 })}px;
	}
	${only("md")} {
		flex-basis: ${settings.contentWidth.md}px;
		height: ${getGridHeight({ rows: 32 })}px;
	}
	${only("sm")} {
		flex-basis: ${settings.contentWidth.sm}px;
		height: ${getGridHeight({ rows: 28 })}px;
	}
	${down("xs")} {
		flex-basis: ${(props) =>
			getGridWidth({ windowW: props.windowW }) -
			settings.baseGrid.fontSize * 4}px;
		height: ${getGridHeight({ rows: 24 })}px;
	}
`;
export const ContentItem = styled(motion.div)<{
	contentsize: { width: number; height: number };
}>`
	display: flex;
	width: ${(props) => props.contentsize.width}px;
	height: ${(props) => props.contentsize.height}px;
	position: absolute;
	left: 0;
	top: 0;
	& > * {
		flex: 0 0 50%;
	}
	${down("lg")} {
		flex-direction: column;
	}
`;
export const ImgFrame = styled.figure`
	background-color: #ddd;
	overflow: hidden;
	${only("md")} {
		flex-basis: ${getGridHeight({ rows: 16 })}px;
	}
	${only("sm")} {
		flex-basis: ${getGridHeight({ rows: 10 })}px;
	}
	${down("xs")} {
		flex-basis: ${getGridHeight({ rows: 8 })}px;
	}
`;
export const Img = styled.img`
	display: block;
	width: 110%;
`;
export const Text = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-self: stretch;
	background-color: #fff;
	padding: 6rem;
	${down("lg")} {
		flex: 1 0 auto;
	}
	${between("md", "lg")} {
		padding: 3rem;
	}
	${down("sm")} {
		padding: 2rem;
	}
`;
export const Heading = styled.p`
	font-weight: 700;
	font-family: ${settings.font.jp};
	color: ${settings.color.main};
	font-size: 21.3333px;
	letter-spacing: 2px;
	line-height: 39.3333px;
	white-space: pre-line;
	${down("xs")} {
		line-height: 28px;
	}
`;
export const Caption = styled.p`
	font-weight: 500;
	font-family: ${settings.font.jp};
	color: ${settings.color.main};
	font-size: 16px;
	letter-spacing: 2.2857px;
	line-height: 36px;
	white-space: pre-line;
	${Heading} + & {
		margin-top: 12px;
	}
	${down("xs")} {
		line-height: 28px;
	}
`;
export const NumberBar = styled.div`
	display: flex;
	position: relative;
	margin-top: ${getGridHeight({
		rows: 1,
		withTopGap: true,
	})}px;
	height: ${getGridHeight({
		rows: 1,
		withTopGap: true,
	})}px;
`;
export const Number = styled.button<{ active: boolean }>`
	font-weight: 700;
	font-style: normal;
	font-family: ${settings.font.en};
	color: ${(props) =>
		props.active ? settings.color.accent : settings.color.gray};
	font-size: 25px;
	letter-spacing: 2.54px;
	line-height: 1;
	display: block;
	text-align: left;
	& + & {
		margin-left: 1rem;
	}
`;
export const NumberIndicator = styled(motion.div)`
	width: 1rem;
	height: 2px;
	background-color: ${settings.color.accent};
	position: absolute;
	left: 0;
	bottom: 0;
	transform: translate(-50%, 100%);
`;
